import * as Api from "./api";
import { showError } from "actions/actionCreators/snackbarActions";
import * as types from "./actionTypes";
import * as eventTypes from "./eventTypes";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";

export function loadDocumentProperties(documentId, siteId) {
  return async dispatch => {
    const key = `${documentId}-${siteId}`;

    try {
      dispatch({ type: types.LOAD_DOCUMENT_PROPERTIES_STARTED, id: key });
      const documentProperties = await dispatch(sendHttpRequest(Api.getDocumentProperties(documentId, siteId)));
      dispatch({ type: types.LOAD_DOCUMENT_PROPERTIES_SUCCESS, payload: { documentProperties }, id: key });
    } catch (error) {
      dispatch({ type: types.LOAD_DOCUMENT_PROPERTIES_FAILED });
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateDocumentProperties(documentId, siteId, documentProperties) {
  return async dispatch => {
    try {
      const key = `${documentId}-${siteId}`;

      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          Api.updateDocumentProperties(documentId, siteId, documentProperties),
          "UpdateDocumentProperties",
          [eventTypes.DOCUMENT_PROPERTIES_UPDATED]
        )
      );

      if (event.ok)
        dispatch({ type: types.UPDATE_DOCUMENT_PROPERTIES_SUCCEEDED, payload: { documentProperties }, id: key });

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
export function loadPropertyDetails(propId) {
  return () => Api.getPropertyDetails(propId);
}
